import axios from "axios";

export const API_INFORMES =
  "https://institutobilinguelasnaciones.com/terapias/backend/informesClinicos.php";

/** Respaldo si informesClinicos.php no está en el servidor */
export const API_CONSULTA_TERAPIA =
  "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";

/** Impresión PDF — misma ruta que reporteHorarioPaciente, datosPacienteEspecialista, etc. */
export const API_INFORMES_PDF =
  "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/";

export const API_INFORMES_BACKEND =
  "https://institutobilinguelasnaciones.com/terapias/backend/";

export const MSG_FIRMA_PDF_REQUERIDA =
  "Debe subir su firma antes de imprimir el PDF. Sin la firma no podra imprimir el informe.";

export const TIPO_INFORME_EVAL_PLAN = "EVAL_PLAN";
export const TIPO_INFORME_EVAL_INICIAL = "EVAL_INICIAL";
export const TIPO_INFORME_EVAL_AVANCE = "EVAL_AVANCE";

/** Rama clínica del informe (plantillas distintas por especialidad) */
export const RAMA_OCUPACIONAL = "OCUPACIONAL";
export const RAMA_SENSORIAL = "SENSORIAL";

/** Plantillas con formulario y PDF implementados */
export const RAMAS_CON_PLANTILLA = [RAMA_OCUPACIONAL, RAMA_SENSORIAL];

export function ramaDesdeTerapia(terapia) {
  const texto = String(
    (terapia && (terapia.nombreEspecialidad || terapia.tipoEvaluacion)) || ""
  ).toUpperCase();
  if (texto.indexOf("SENSORIAL") >= 0) return RAMA_SENSORIAL;
  if (texto.indexOf("OCUPACIONAL") >= 0 || texto.indexOf("OCUPAC") >= 0) {
    return RAMA_OCUPACIONAL;
  }
  if (texto.indexOf("PSICOLOG") >= 0) return "PSICOLOGIA";
  if (texto.indexOf("FONOAUDIO") >= 0) return "FONOAUDIOLOGIA";
  return "OTRA";
}

export function tipoInformeConRama(tipoBase, rama) {
  if (rama === RAMA_SENSORIAL) {
    if (tipoBase === TIPO_INFORME_EVAL_INICIAL) return "EVAL_INICIAL_SENS";
    if (tipoBase === TIPO_INFORME_EVAL_AVANCE) return "EVAL_AVANCE_SENS";
    return "EVAL_PLAN_SENS";
  }
  if (rama === RAMA_OCUPACIONAL) {
    if (tipoBase === TIPO_INFORME_EVAL_INICIAL) return "EVAL_INICIAL_OCUP";
    if (tipoBase === TIPO_INFORME_EVAL_AVANCE) return "EVAL_AVANCE_OCUP";
    return "EVAL_PLAN_OCUP";
  }
  return tipoBase + "_" + String(rama || "OTRA");
}

export function tienePlantillaInforme(rama) {
  return RAMAS_CON_PLANTILLA.indexOf(rama) >= 0;
}

export function etiquetaRama(rama) {
  if (rama === RAMA_SENSORIAL) return "Integración Sensorial";
  if (rama === RAMA_OCUPACIONAL) return "Terapia Ocupacional";
  if (rama === "PSICOLOGIA") return "Psicología";
  if (rama === "FONOAUDIOLOGIA") return "Fonoaudiología";
  return rama || "Otra";
}

export function pdfEvalInicialScript(rama) {
  if (rama === RAMA_OCUPACIONAL) return "informeEvaluacionInicial.php";
  if (rama === RAMA_SENSORIAL) return "informeEvaluacionInicialSensorial.php";
  return "informeEvaluacionInicial.php";
}

export function pdfEvalPlanScript(formato, rama) {
  if (rama === RAMA_SENSORIAL) return "informeEvaluacionPlanSensorial.php";
  if (rama !== RAMA_OCUPACIONAL) return "";
  // Un solo PHP: el formato (infantil/escolar) se lee del informe guardado en BD.
  return "informeEvaluacionPlan.php";
}

export function pdfEvalAvanceScript(rama) {
  if (rama === RAMA_SENSORIAL) return "informeEvaluacionAvanceSensorial.php";
  if (rama !== RAMA_OCUPACIONAL) return "";
  return "informeEvaluacionAvance.php";
}

export function tituloFormularioEvalInicial(rama) {
  if (rama === RAMA_SENSORIAL) {
    return "Evaluación Inicial — Integración Sensorial";
  }
  return "Evaluación Inicial de Terapia Ocupacional";
}

function esFormatoAmplioSensorial(datos) {
  return !!(
    datos &&
    (datos.cognicion ||
      datos.sistemasSensoriales ||
      datos.conducta ||
      datos.antecedentes)
  );
}

function esFormatoOcupacionalV2(datos) {
  return !!(
    datos &&
    (datos.juego ||
      datos.procesamientoSensorial ||
      datos.comunicacionSocial ||
      (datos.avd && datos.avd.controlEsfinteres))
  );
}

/** Normaliza JSON guardado de evaluación inicial sensorial (formato amplio). */
export function normalizarDatosEvalInicialSensorial(datos) {
  const base = emptyDatosEvalInicialSensorial();
  if (!datos || typeof datos !== "object") {
    return base;
  }
  if (esFormatoAmplioSensorial(datos)) {
    return {
      ...base,
      ...datos,
      datosGenerales: { ...base.datosGenerales, ...(datos.datosGenerales || {}) },
      antecedentes: { ...base.antecedentes, ...(datos.antecedentes || {}) },
      avd: { ...base.avd, ...(datos.avd || {}) },
      avdInstrumentales: { ...base.avdInstrumentales, ...(datos.avdInstrumentales || {}) },
      conducta: { ...base.conducta, ...(datos.conducta || {}) },
      cognicion: { ...base.cognicion, ...(datos.cognicion || {}) },
      sistemasSensoriales: {
        ...base.sistemasSensoriales,
        ...(datos.sistemasSensoriales || {}),
      },
      motricidadFina: { ...base.motricidadFina, ...(datos.motricidadFina || {}) },
      motricidadGruesa: { ...base.motricidadGruesa, ...(datos.motricidadGruesa || {}) },
      objetivos: datos.objetivos != null ? datos.objetivos : base.objetivos,
      recomendaciones:
        datos.recomendaciones != null ? datos.recomendaciones : base.recomendaciones,
      recibido: datos.recibido != null ? datos.recibido : base.recibido,
      observacionesGenerales:
        datos.observacionesGenerales != null
          ? datos.observacionesGenerales
          : base.observacionesGenerales,
    };
  }
  if (esFormatoOcupacionalV2(datos)) {
    const dg = datos.datosGenerales || {};
    const inst = datos.avdInstrumentales || {};
    const cog = datos.cognicion || {};
    const ps = datos.procesamientoSensorial || {};
    const cs = datos.comunicacionSocial || {};
    return {
      ...base,
      datosGenerales: { ...base.datosGenerales, ...dg },
      antecedentes: { ...base.antecedentes, ...(datos.antecedentes || {}) },
      avd: {
        ...base.avd,
        vestido: datos.avd?.vestido || "",
        higiene: datos.avd?.higiene || "",
        alimentacion: datos.avd?.alimentacion || "",
      },
      avdInstrumentales: {
        instrumentales: inst.instrumentales || inst.tareasHogar || "",
      },
      conducta: { conducta: cs.conducta || datos.conducta?.conducta || "" },
      cognicion: {
        ...base.cognicion,
        comunicacion: cs.lenguaje || cog.comunicacion || "",
        desempenoEscolar: datos.desempenoEscolar?.participacion || cog.desempenoEscolar || "",
        social: cs.interaccionSocial || cog.social || "",
      },
      sistemasSensoriales: { ...base.sistemasSensoriales, ...ps },
      motricidadFina: { ...base.motricidadFina, ...(datos.motricidadFina || {}) },
      motricidadGruesa: { ...base.motricidadGruesa, ...(datos.motricidadGruesa || {}) },
      objetivos: datos.objetivos != null ? datos.objetivos : base.objetivos,
      recomendaciones:
        datos.recomendaciones != null ? datos.recomendaciones : base.recomendaciones,
      recibido: datos.recibido != null ? datos.recibido : base.recibido,
    };
  }
  return {
    ...base,
    ...datos,
    datosGenerales: { ...base.datosGenerales, ...(datos.datosGenerales || {}) },
  };
}

/** Normaliza JSON guardado de informe de avance sensorial. */
export function normalizarDatosEvalAvanceSensorial(datos) {
  const base = emptyDatosEvalAvanceSensorial();
  if (!datos || typeof datos !== "object") {
    return base;
  }
  if (datos.motivoConsulta != null || datos.conductaObservada != null) {
    return {
      ...base,
      ...datos,
      datosGenerales: { ...base.datosGenerales, ...(datos.datosGenerales || {}) },
    };
  }
  if (esFormatoAmplioSensorial(datos)) {
    const dg = datos.datosGenerales || {};
    return {
      ...base,
      datosGenerales: {
        ...base.datosGenerales,
        nombreApellido: dg.nombreApellido || "",
        fnacimiento: dg.fnacimiento || "",
        edadTexto: dg.edadTexto || dg.edad || "",
        escuela: dg.colegio || dg.escuela || "",
        tutorLegal: dg.nombreMadre || dg.nombrePadre || "",
        domicilio: dg.domicilio || "",
        fechaInforme: dg.fechaInforme || "",
        diagnostico: dg.diagnostico || "",
      },
    };
  }
  return {
    ...base,
    ...datos,
    datosGenerales: { ...base.datosGenerales, ...(datos.datosGenerales || {}) },
  };
}

/** Normaliza JSON guardado (formato anterior o nuevo) al esquema actual. */
export function normalizarDatosEvalInicial(datos) {
  const base = emptyDatosEvalInicial();
  if (!datos || typeof datos !== "object") {
    return base;
  }
  const out = {
    ...base,
    ...datos,
    datosGenerales: { ...base.datosGenerales, ...(datos.datosGenerales || {}) },
    antecedentes: { ...base.antecedentes, ...(datos.antecedentes || {}) },
    avd: { ...base.avd, ...(datos.avd || {}) },
    avdInstrumentales: { ...base.avdInstrumentales, ...(datos.avdInstrumentales || {}) },
    juego: { ...base.juego, ...(datos.juego || {}) },
    desempenoEscolar: { ...base.desempenoEscolar, ...(datos.desempenoEscolar || {}) },
    ocioTiempoLibre: { ...base.ocioTiempoLibre, ...(datos.ocioTiempoLibre || {}) },
    comunicacionSocial: { ...base.comunicacionSocial, ...(datos.comunicacionSocial || {}) },
    procesamientoSensorial: {
      ...base.procesamientoSensorial,
      ...(datos.procesamientoSensorial || {}),
    },
    motricidadFina: { ...base.motricidadFina, ...(datos.motricidadFina || {}) },
    motricidadGruesa: { ...base.motricidadGruesa, ...(datos.motricidadGruesa || {}) },
    objetivos: datos.objetivos != null ? datos.objetivos : base.objetivos,
    recomendaciones: datos.recomendaciones != null ? datos.recomendaciones : base.recomendaciones,
    recibido: datos.recibido != null ? datos.recibido : base.recibido,
  };

  const inst = datos.avdInstrumentales || {};
  if (inst.instrumentales && !out.avdInstrumentales.tareasHogar) {
    out.avdInstrumentales.tareasHogar = inst.instrumentales;
  }

  const cog = datos.cognicion || {};
  const cond = datos.conducta || {};
  if (!out.comunicacionSocial.conducta && cond.conducta) {
    out.comunicacionSocial.conducta = cond.conducta;
  }
  if (!out.comunicacionSocial.lenguaje && cog.comunicacion) {
    out.comunicacionSocial.lenguaje = cog.comunicacion;
  }
  if (!out.comunicacionSocial.interaccionSocial && cog.social) {
    out.comunicacionSocial.interaccionSocial = cog.social;
  }
  if (!out.desempenoEscolar.participacion && cog.desempenoEscolar) {
    out.desempenoEscolar.participacion = cog.desempenoEscolar;
  }
  if (!out.procesamientoSensorial.visual && cog.sensorial) {
    out.procesamientoSensorial.visual = cog.sensorial;
  }

  return out;
}

export function urlFirmaEspecialista(rutaRelativa) {
  if (!rutaRelativa) return "";
  const base = API_INFORMES_BACKEND.replace(/\/$/, "");
  const path = String(rutaRelativa).replace(/^\//, "");
  return base + "/" + path + "?t=" + Date.now();
}

export async function estadoFirmaEspecialista(cedulaEspecialista) {
  const data = new FormData();
  data.append("boton", "firmaEspecialistaEstado");
  data.append("cedulaEspecialista", cedulaEspecialista || "");
  const res = await axios.post(API_INFORMES, data);
  const ok = res.data && res.data.variable1;
  return {
    tiene: !!(ok && res.data.variable2),
    ruta: ok && res.data.variable3 ? res.data.variable3 : "",
  };
}

export async function subirFirmaEspecialista(cedulaEspecialista, file) {
  const data = new FormData();
  data.append("boton", "subirFirmaEspecialista");
  data.append("cedulaEspecialista", cedulaEspecialista || "");
  data.append("firma", file);
  const res = await axios.post(API_INFORMES, data);
  return res.data;
}

export async function solicitarAyudaInformePlan({
  idasociarE,
  idasociarEGrupo,
  formato,
  contextoPaciente,
}) {
  const data = new FormData();
  data.append("boton", "generarAyudaInformePlan");
  data.append("idasociarE", idasociarE || "");
  const ids =
    Array.isArray(idasociarEGrupo) && idasociarEGrupo.length > 0
      ? idasociarEGrupo.join(",")
      : String(idasociarE || "");
  data.append("idasociarEGrupo", ids);
  data.append("formato", formato === "ESCOLAR" ? "ESCOLAR" : "INFANTIL");
  data.append("contextoPaciente", contextoPaciente || "");
  const res = await axios.post(API_INFORMES, data);
  return res.data;
}

export async function eliminarFirmaEspecialista(cedulaEspecialista) {
  const data = new FormData();
  data.append("boton", "eliminarFirmaEspecialista");
  data.append("cedulaEspecialista", cedulaEspecialista || "");
  const res = await axios.post(API_INFORMES, data);
  return res.data;
}

const emptyGrupo = (keys) => {
  const o = {};
  keys.forEach((k) => {
    o[k] = "";
  });
  return o;
};

export const emptyDatosEvalInicial = (base = {}) => ({
  datosGenerales: {
    nombreApellido: "",
    cedula: "",
    sexo: "",
    fnacimiento: "",
    edad: "",
    edadTexto: "",
    diagnostico: "",
    nombreMadre: "",
    ocupacionMadre: "",
    nombrePadre: "",
    ocupacionPadre: "",
    hermanos: "",
    colegio: "",
    gradoEscolar: "",
    referencia: "",
    condicionSalud: "",
    alergias: "",
    medicamentos: "",
    fechaInforme: "",
    fechaInicioTerapia: "",
    ...base,
  },
  antecedentes: emptyGrupo(["preNatal", "natal", "postNatal"]),
  avd: emptyGrupo([
    "vestido",
    "higiene",
    "alimentacion",
    "controlEsfinteres",
    "higieneSueno",
    "movilidad",
  ]),
  avdInstrumentales: emptyGrupo(["tareasHogar", "manejoDinero"]),
  juego: emptyGrupo(["tipoJuego"]),
  desempenoEscolar: emptyGrupo(["participacion"]),
  ocioTiempoLibre: emptyGrupo(["participacion"]),
  comunicacionSocial: emptyGrupo(["conducta", "interaccionSocial", "lenguaje"]),
  procesamientoSensorial: emptyGrupo([
    "visual",
    "tactil",
    "auditivo",
    "gustativo",
    "olfativo",
    "propioceptivo",
    "interoceptivo",
    "vestibular",
  ]),
  motricidadFina: emptyGrupo([
    "dominancia",
    "coordinacionBimanual",
    "ojoMano",
    "ensartar",
    "encajar",
    "enhebrar",
    "bolitas",
    "amasaMasilla",
    "aplastaMasilla",
    "cortaMasillaUtensilios",
    "rasgarPapel",
    "coloreoLimites",
    "coloreoDireccion",
    "coloreoFuerza",
    "trazosRectasHV",
    "trazosZigzag",
    "trazosCurvas",
    "numeros",
    "letras",
    "dibujos",
    "tijerasRecta",
    "tijerasCurvas",
    "tijerasZigzag",
    "agarreLapiz",
    "fuerzaLapiz",
    "observaciones",
  ]),
  motricidadGruesa: emptyGrupo([
    "coordinacionBilateral",
    "oculomotor",
    "lateralidad",
    "equilibrioEstatica",
    "equilibrioMovimiento",
    "equilibrioUnPie",
    "caminarLineaRecta",
    "saltar",
    "saltarUnPie",
    "saltarAmbosPies",
    "caminarPuntillas",
    "camina",
    "corre",
    "trepa",
    "subeEscalerasAlterna",
    "subeEscalerasVerticales",
    "pateaEstatica",
    "pateaMovimiento",
    "lanzaAmbasManos",
    "atrapaAmbasManos",
    "lanzaUnaMano",
    "atrapaUnaMano",
    "encestaFijo",
    "encestaMovimiento",
    "halar",
    "empujar",
    "fuerza",
    "observaciones",
  ]),
  objetivos: "",
  recomendaciones: "",
  recibido: "",
});

export const emptyDatosEvalPlan = (base = {}) => ({
  datosGenerales: {
    nombreApellido: "",
    cedula: "",
    fnacimiento: "",
    edad: "",
    domicilio: "",
    sexo: "",
    diagnostico: "",
    referidoPor: "",
    colegio: "",
    escuela: "",
    gradoEscolar: "",
    medicamentos: "",
    alergias: "",
    nombreMadre: "",
    telefonoMadre: "",
    nombrePadre: "",
    fechaInforme: "",
    fechaInicioTerapia: "",
    ...base,
  },
  motivoMenor: "",
  motivoAcompanante: "",
  motivoReferido: "",
  perfilOcupacional: "",
  objetivo: "",
  organizacionComportamiento: "",
  abvd: {
    alimentacion: "",
    vestido: "",
    controlEsfinter: "",
    higiene: "",
    descansoSueno: "",
  },
  aivd: {
    tareasCasa: "",
    pantallas: "",
    dinero: "",
    cuidadoOtros: "",
    tiempoPlanificacion: "",
    transporte: "",
  },
  motor: {
    gruesas: "",
    finas: "",
    observacionesPosturales: "",
    lateralidad: "",
  },
  cognitivo: {
    percepcionVisual: "",
    funcionesEjecutivas: "",
    atencion: "",
    memoria: "",
    procesamientoEspacial: "",
  },
  sensorial: "",
  comunicacion: "",
  evaluaciones: "",
  impresionOcupacional: "",
  objetivosTrimestre: "",
  recomendaciones: "",
  firmaTerapeuta: "",
  firmaPadre: "",
});

export const emptyDatosEvalPlanSensorial = (base = {}) => ({
  datosGenerales: {
    nombreApellido: "",
    fnacimiento: "",
    edad: "",
    edadTexto: "",
    centroEducativo: "",
    diagnostico: "",
    nombreTerapeuta: "",
    fechaEvaluacion: "",
    fechaInforme: "",
    ...base,
  },
  motivoReferencia: "",
  antecedentesRelevantes: "",
  instrumentosUtilizados: "",
  metodosEvaluacion: "",
  observacionClinica: "",
  resultadosPerfilSensorial: "",
  conclusion: "",
  planIntervencion: "",
  objetivosIntervencion: "",
  recomendaciones: "",
  sugerencias: "",
  dietaSensorial: "",
});

export const emptyDatosEvalInicialSensorial = (base = {}) => ({
  datosGenerales: {
    nombreApellido: "",
    cedula: "",
    sexo: "",
    fnacimiento: "",
    edad: "",
    edadTexto: "",
    diagnostico: "",
    nombreMadre: "",
    ocupacionMadre: "",
    nombrePadre: "",
    ocupacionPadre: "",
    hermanos: "",
    colegio: "",
    gradoEscolar: "",
    referencia: "",
    condicionSalud: "",
    alergias: "",
    medicamentos: "",
    fechaInforme: "",
    fechaInicioTerapia: "",
    ...base,
  },
  antecedentes: emptyGrupo(["preNatal", "natal", "postNatal"]),
  avd: emptyGrupo(["vestido", "higiene", "alimentacion"]),
  avdInstrumentales: { instrumentales: "" },
  conducta: { conducta: "" },
  cognicion: emptyGrupo([
    "comunicacion",
    "percepcion",
    "atencion",
    "concentracion",
    "seguimientoIndicaciones",
    "memoria",
    "esquemaCorporal",
    "relacionesEspaciales",
    "colores",
    "figurasGeometricas",
    "numeros",
    "seguimientoPatrones",
    "copia",
    "cierreVisual",
    "figuraFondo",
    "lectura",
    "escritura",
    "procedimientosMatematicos",
    "desempenoEscolar",
    "social",
  ]),
  sistemasSensoriales: emptyGrupo([
    "propioceptivo",
    "vestibular",
    "tactil",
    "auditivo",
    "visual",
    "olfato",
    "gusto",
    "interoceptivo",
  ]),
  motricidadFina: emptyGrupo([
    "dominancia",
    "coordinacionBimanual",
    "ojoMano",
    "ensartar",
    "encajar",
    "enhebrar",
    "bolitas",
    "amasaMasilla",
    "aplastaMasilla",
    "cortaMasillaUtensilios",
    "rasgarPapel",
    "coloreoLimites",
    "coloreoDireccion",
    "coloreoFuerza",
    "trazosRectasHV",
    "trazosZigzag",
    "trazosCurvas",
    "numeros",
    "letras",
    "dibujos",
    "tijerasRecta",
    "tijerasCurvas",
    "tijerasZigzag",
    "agarreLapiz",
    "fuerzaLapiz",
    "observaciones",
  ]),
  motricidadGruesa: emptyGrupo([
    "coordinacionBilateral",
    "oculomotor",
    "lateralidad",
    "equilibrioEstatica",
    "equilibrioMovimiento",
    "equilibrioUnPie",
    "caminarLineaRecta",
    "saltar",
    "saltarUnPie",
    "saltarAmbosPies",
    "caminarPuntillas",
    "camina",
    "corre",
    "trepa",
    "subeEscalerasAlterna",
    "subeEscalerasVerticales",
    "pateaEstatica",
    "pateaMovimiento",
    "lanzaAmbasManos",
    "atrapaAmbasManos",
    "lanzaUnaMano",
    "atrapaUnaMano",
    "encestaFijo",
    "encestaMovimiento",
    "halar",
    "empujar",
    "fuerza",
    "observaciones",
  ]),
  observacionesGenerales: "",
  objetivos: "",
  recomendaciones: "",
  recibido: "",
});

export const emptyDatosEvalAvanceSensorial = (base = {}) => ({
  datosGenerales: {
    nombreApellido: "",
    fnacimiento: "",
    edad: "",
    edadTexto: "",
    escuela: "",
    tutorLegal: "",
    domicilio: "",
    fechaEvaluacion: "",
    fechaInforme: "",
    diagnostico: "",
    elaboradoPor: "",
    cantidadSesionesRecibidas: "",
    ...base,
  },
  motivoConsulta: "",
  conductaObservada: "",
  tecnicasUtilizadas: "",
  aspectosFortalecer: "",
  recomendaciones: "",
  recomendacionesCentroEducativo: "",
  cantidadSesiones: "",
  recibidoPadre: "",
});

export const emptyDatosEvalAvance = (base = {}) => ({
  datosGenerales: {
    nombreApellido: "",
    fnacimiento: "",
    edad: "",
    edadTexto: "",
    diagnostico: "",
    nombreTerapeuta: "",
    fechaInforme: "",
    fechaInicioTerapia: "",
    ...base,
  },
  areasFinalidad: "",
  vecesPorSemana: "",
  diasTerapiaTexto: "",
  horarioDesde: "",
  horarioHasta: "",
  asistencia: "",
  evolucionIntro: "",
  regulacion: "",
  atencion: "",
  motor: "",
  procesamientoSensorial: "",
  conductual: "",
  conclusion: "",
  objetivosTerapeuticos: "",
  recomendaciones: "",
});
